import classes from './ContentTypeTemplate.module.scss'
import { MouseEvent } from 'react'
import { useDispatch } from 'react-redux'
import { IAttachmentBulkFileObject } from '../AddAttachmentsBulkV2'
import { Dropdown } from 'primereact/dropdown'
import {
  CertificateDocumentTypeV2,
  ECMContentType,
} from '../../../../../../enums/CertificateDocumentType'
import { IContentType } from '../../../../../../enums/CetificateFileContentType'
import { updateAttachmentList } from '../../../../../../features/createCertificate/createCertificateSlice'
import { getContentTypeDescription } from '../../../../../../utils/constants/certificate-attachment.constants'

interface ContentTypeTemplateProps {
  activeDocumentType: CertificateDocumentTypeV2
  rowData: IAttachmentBulkFileObject
  list: Array<IContentType>
}

const ContentTypeTemplate = (props: ContentTypeTemplateProps) => {
  const { activeDocumentType, rowData, list } = props
  const dispatch = useDispatch()
  const contentTypeDescription = getContentTypeDescription(rowData)

  const onContentTypeChange = (e: { value: any }) => {
    let value = ECMContentType.None
    if (e.value != undefined) value = e.value

    dispatch(
      updateAttachmentList([
        {
          tempUniqueId: rowData.tempUniqueId,
          newValue: value,
          group_index: activeDocumentType,
        },
      ])
    )
  }

  const preventClickPropagation = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault()
    event.stopPropagation()
  }

  return (
    <>
      <div onClick={preventClickPropagation} style={{ width: '100%' }}>
        <Dropdown
          tooltip={contentTypeDescription}
          value={rowData?.ecmContentType}
          options={list}
          onChange={onContentTypeChange}
          optionLabel="name"
          optionValue="value"
          className={classes['custom-dropdown']}
          style={{ fontSize: '10px', width: '100%' }}
          optionDisabled="disabled"
          placeholder="Select"
          showClear={rowData?.ecmContentType !== ECMContentType.None}
        />
      </div>
    </>
  )
}

export default ContentTypeTemplate
